import MenuModalBody from "./MenuModalBody";

export default MenuModalBody;